import * as React from "react";

/**
 * Provided by a browser that shows a device type's files as one device
 * inherits them. The parts of the browser that read it drop their write
 * actions and mark the files the device overrides.
 */
export interface InheritedFiles {
  /**
   * Paths on the current page where the device holds a file of its own,
   * which the device uses in place of the type's.
   */
  overriddenPaths: ReadonlySet<string>;
}

export const InheritedFilesContext = React.createContext<InheritedFiles | null>(
  null,
);

/** The inherited files being shown, or `null` when the browser shows an association's own files. */
export function useInheritedFiles(): InheritedFiles | null {
  return React.useContext(InheritedFilesContext);
}
